import React, { useState,useEffect } from 'react'
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    IconButton,
    Input,
    Text,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Tooltip,
    Select,
    Radio,
    RadioGroup,
    Switch,
} from '@chakra-ui/react'
import { VscEdit } from 'react-icons/vsc'
import { useDispatch } from 'react-redux';
import { updateCliente, getClientes } from '../../features/clienteSlice';
import { useSelector } from 'react-redux';
import { getListSelectCiudad } from '../../features/ciudadSlice';

export const ModalEditarCliente = ({ row, page, perPage }) => {
    //const isFormValid = !!indice.ciudad?.trim() && !!indice.paisId;
    const dispatch = useDispatch();
    const { ciudades } = useSelector((state) => state.ciudades); // Suponiendo que el reducer se llama 'coidades'
   // const user = useSelector(state => state.auth.user);

    const isValidEmail = (email) => {
           return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
       };
       const [emailError, setEmailError] = useState('');
   
   useEffect(() => {
        dispatch(getListSelectCiudad());
    }, [dispatch]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = {
        nombre: '',
        apellido: '',
        dni: '',
        direccion: '',
        celular: '',
        email: '',
        fechaNacimiento: '',
        tipoPersona: '',
        ciudadId: '',
        estado: null
    }

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = (data) => {
        setIsModalOpen(true);
        setIndice({ ...data }); // ✅ Clona el objeto para evitar referencias circulares
    };

    const handleModalClose = () => {
        setIsModalOpen(false)
    }

    const handleUpdate = (indice) => {
        dispatch(updateCliente(indice)).then(() => {
            dispatch(getClientes({ page, perPage })); // Usa los valores pasados como props y Actualiza la tabla después de eliminar
            setIsModalOpen(false); // Cierra el modal
        });
    };
    const isFormValid = !!indice.nombre?.trim() && !!indice.ciudadId;

    return (
        <>
            <Tooltip hasArrow label='Editar' placement='auto'>
                <IconButton
                    colorScheme="blackAlpha"
                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                    aria-label="Editar"
                    icon={<Icon as={VscEdit}
                        fontSize="2xl" />}
                    variant="ghost"
                    onClick={() => handleModalOpen(row)}
                    ml={2}
                />
            </Tooltip>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">ACTUALIZAR CLIENTE</ModalHeader>
                    <ModalCloseButton />
                     <ModalBody>
                        

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <Text fontWeight="semibold">ESTADO</Text>
                            <Switch onChange={(e) => setIndice({ ...indice, estado: e.target.checked })} value={indice ? indice.estado : null} colorScheme="purple" isChecked={indice.estado === true ? true : false} size='lg' />
                         </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.nombre : ''}
                                        placeholder="Ingrese el nombre del cliente"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, nombre: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl>
                                <FormLabel fontWeight="semibold">APELLIDO</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.apellido : ''}
                                        placeholder="Ingrese el apellido del cliente"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, apellido: e.target.value })}
                                    />
                            </FormControl>
                            
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">DNI/RUC</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.dni : ''}
                                        placeholder="Ingrese el DNI o RUC"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, dni: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl isRequired>
                                <FormLabel fontWeight={'semibold'}>TIPO DE PERSONA</FormLabel>
                                    <RadioGroup
                                        value={indice.tipoPersona? 'true' : 'false'} // importante para mostrar el valor actual
                                        onChange={(value) => setIndice({ ...indice, tipoPersona: value === "true" })}
                                        
                                    >
                                        <Stack direction="row">
                                        <Radio value="true">FISICA</Radio>
                                        <Radio value="false">JURIDICA</Radio>
                                        </Stack>
                                </RadioGroup>
                            </FormControl>
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl>
                                <FormLabel fontWeight="semibold">DIRECCION</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.direccion : ''}
                                        placeholder="Ingrese la dirección"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, direccion: e.target.value })}
                                    />
                            </FormControl>
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight={'semibold'}>CIUDAD</FormLabel>
                                <Select
                                    placeholder="Seleccione una ciudad"
                                    onChange={(e) => setIndice({ ...indice, ciudadId: e.target.value })}
                                    value={indice.ciudadId}
                                >
                                    {ciudades.map((ciudad) => (
                                        <option key={ciudad.id} value={ciudad.id}>
                                            {ciudad.descripcion}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl isInvalid={!!emailError}>
                                <FormLabel fontWeight="semibold">EMAIL</FormLabel>
                                <Input
                                    defaultValue={indice ? indice.email : ''}
                                    placeholder="Ingrese el email"
                                    type="email"
                                    value={indice.email || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setIndice({ ...indice, email: value });

                                        if (!isValidEmail(value)) {
                                            setEmailError('El correo no es válido');
                                        } else {
                                            setEmailError('');
                                        }
                                    }}
                                />
                                {emailError && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                        {emailError}
                                    </Text>
                                )}
                            </FormControl>
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl>
                                <FormLabel fontWeight="semibold">CELULAR</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.celular : ''}
                                        placeholder="Ingrese el # de celular"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, celular: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl>
                                <FormLabel fontWeight={'semibold'}>FECHA DE NACIMIENTO</FormLabel>
                                <Input
                                    defaultValue={indice ? indice.fechaNacimiento : ''}
                                    type="date"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setIndice({ ...indice, fechaNacimiento: value ? value : null });
                                    }}
                                />
                            </FormControl>            
                        </Stack>
                    
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="red"
                            _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleModalClose}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            _dark={{ bg: "green.600", color: "white", _hover: { bg: "green.800" } }}
                            size="lg"
                            mr={3}
                            onClick={() => handleUpdate(indice)} // ✅ Ahora pasa `indice`
                            borderRadius="xl"
                            isDisabled={!isFormValid}
                        >
                            ACTUALIZAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
